import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  getDraftTrackedTime,
  getDraftTrackedTimeError,
  IState,
  selectFeature,
} from './tracked-time-data.reducer';
import { EntityDataStore } from '../entity-data/entity-data.store';
import { IError } from '../entity-data/entity-data.data';
import { TrackedTime } from './models/tracked-time.model';

@Injectable()
export class TrackedTimeDataStore extends EntityDataStore<IState, TrackedTime> {
  constructor(store: Store<any>) {
    super(store, selectFeature);
  }

  getDraftTrackedTime(): Observable<TrackedTime> {
    return this.store.select(getDraftTrackedTime());
  }

  getDraftTrackedTimeError(): Observable<IError> {
    return this.store.select(getDraftTrackedTimeError());
  }
}
